import { adminConstants } from '../constant/admin-constant';

const initialState = {loadingProShowFile: false, proShowFileData:[]};
export function proShowFileReducer(state = initialState, action){

	switch(action.type){


		case adminConstants.PAGINATE_PRO_SHOW_FILE_REQUEST:
			return { ...state, loadingProShowFile:true}
		case adminConstants.PAGINATE_PRO_SHOW_FILE_SUCCESS:
			// return { ...state, loadingProShowFile:false, proShowFileData: action.payload.data.pagination.data, pages:action.payload.data.pagination.last_page, current_page:action.payload.data.pagination.current_page };
			return {
                ...state,
                loadingProShowFile:false,
                proShowFileData: action.payload && action.payload.data && action.payload.data.pagination && action.payload.data.pagination.data ? action.payload.data.pagination.data : initialState.proShowFileData,
                pages: action.payload && action.payload.data && action.payload.data.pagination && action.payload.data.pagination.last_page && action.payload.data.pagination.last_page,
                current_page: action.payload && action.payload.data && action.payload.data.pagination && action.payload.data.pagination.current_page && action.payload.data.pagination.current_page
            };
		case adminConstants.PAGINATE_PRO_SHOW_FILE_FAILURE:
			return { ...state, loadingProShowFile:false, error:action.payload };

		case adminConstants.STORE_PRO_SHOW_FILE_REQUEST:
			return { ...state, loadingProShowFile:true}
		case adminConstants.STORE_PRO_SHOW_FILE_SUCCESS:
			return { ...state, loadingProShowFile:false, proShowFileStored: action.payload.proShowFileStored};
		case adminConstants.STORE_PRO_SHOW_FILE_FAILURE:
			return { ...state, loadingProShowFile:false, error:action.payload };

		case adminConstants.GET_PRO_SHOW_FILE_REQUEST:
			return { ...state, loadingProShowFile:true};
		case adminConstants.GET_PRO_SHOW_FILE_SUCCESS:
			return { ...state, loadingProShowFile:false, proShowFileShow : action.payload.proShowFile };
		case adminConstants.GET_PRO_SHOW_FILE_FAILURE:
			return { ...state, loadingProShowFile:false, error : action.payload };

		case adminConstants.UPDATE_PRO_SHOW_FILE_REQUEST:
			return { ...state, loadingProShowFile:true}
		case adminConstants.UPDATE_PRO_SHOW_FILE_SUCCESS:
			return { ...state, loadingProShowFile:false, proShowFileUpdated: action.payload.proShowFileUpdated};
		case adminConstants.UPDATE_PRO_SHOW_FILE_FAILURE:
			return { ...state, loadingProShowFile:false, error:action.payload };

		case adminConstants.DELETE_PRO_SHOW_FILE_REQUEST:
			return { ...state, loading:true}
		case adminConstants.DELETE_PRO_SHOW_FILE_SUCCESS:
			return { ...state, loading:false};
		case adminConstants.DELETE_PRO_SHOW_FILE_FAILURE:
			return { ...state, loading:false, error:action.payload };

		default:
			return { ...state };
	}
}
